import { render, staticRenderFns } from "./LeadOferta.vue?vue&type=template&id=6fbee292&scoped=true&lang=pug"
import script from "./LeadOferta.vue?vue&type=script&lang=js"
export * from "./LeadOferta.vue?vue&type=script&lang=js"
import style0 from "./LeadOferta.vue?vue&type=style&index=0&id=6fbee292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbee292",
  null
  
)

export default component.exports